import CatalogLabels from "panels/catalog/Catalog.labels";
import Label from "core/components/label/Label";

export function getProgressTextLabel(progress: string) {
		if (progress === "NotStarted" || !progress) {
			return <Label k={`subscription.${progress}.label`} v="Not Started" />;
		}
		return <Label k={`subscription.${progress}.label`} v={progress} />;
}


// WEBPACK FOOTER //
// ./src/common/fragments/ProgressText.tsx